


























































































import { Component, Mixins } from "vue-property-decorator";

// Mixins
import RequestPromises from "@/mixins/requestPromises";
import CountriesStore from "@/mixins/constants/countriesStore";
import LanguagesStore from "@/mixins/constants/languagesStore";
import HasValidation from "@/mixins/HasValidation";

// Enums/Data
import { DataModules } from "@/store/modules/data";

// Types
import { IBrand, IBrandForm } from "@/models/brands";

@Component
export default class CreateBrandModal extends Mixins(
  RequestPromises,
  CountriesStore,
  LanguagesStore,
  HasValidation
) {
  // Getters

  public brand!: IBrand;

  // Variables

  public form = {
    name: "",
    company_name: "",
    company_address: "",
    company_phone: "",
    company_email: "",
    language_code: "en",
    country_code: "GB",
    currency_code: "GBP",
    vat_number: "",
    tax_type: 0,
    payment_days_term: 0,
    create_invoice_term: 0,
    payment_authorize: false,
    autoapply: false
  } as IBrandForm;

  public isProcessing = false;

  // Methods

  public async validateBeforeSubmit() {
    try {
      if (!(await this.validate())) {
        throw this.$t("_sentence.form_is_not_valid");
      }

      this.isProcessing = true;

      await this.createBrand();

      this.$store.dispatch("toast/show", {
        message: this.$t("_sentence.brand_successfully_created")
      });
      this.$router.push({ name: "brandGeneralSettings" }).catch(() => ({}));
      this.$emit("close");
    } catch (error) {
      this.$store.dispatch("api/handleValidationError", {
        error,
        vm: this
      });
    } finally {
      this.isProcessing = false;
    }
  }

  public createBrand() {
    return this.$store.dispatch(`data/${DataModules.BRANDS}/create`, {
      data: this.form
    });
  }
}
